<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
         <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('companies.created_at_from_to')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.from')}}
                          <el-form-item prop="fechaAltaDesde">
                            <el-date-picker
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.fechaAltaDesde.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaAltaD"
                              @blur="onBlurDatePickerMixin('.datePickerFechaAltaD-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaAltaD-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaAltaD-popover"
                              >
                            </el-date-picker>
                          </el-form-item>
                        </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.to')}}
                        <el-form-item prop="fechaAltaHasta">
                          <el-date-picker
                            class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaAltaHasta.value"
                            :picker-options="dateRangeOptions"
                            type="date"
                            format="dd-MM-yyyy"
                            placeholder="dd-mm-aaaa"
                            ref="datePickerFechaAltaH"
                            @blur="onBlurDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @focus="onBlurDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @keydown.native="captureKeyNotChrome"
                            popper-class="datePickerFechaAltaH-popover"
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.cif')}}
                <el-form-item prop="cif">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.cif.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.companyName')}}
                <el-form-item prop="name">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.name.value"
                    maxlength="255"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <AccessibleElSelect
                v-model="form.automatic_download.value"
                prop="automatic_download"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usercompaniesfilter"
              >
                <template slot="label">{{$t('companies.automatic_download')}}</template>
              </AccessibleElSelect>
            </div>
            <div>
              <AccessibleElSelect
                v-model="form.send_alerts.value"
                prop="send_alerts"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usercompaniesfilter"
              >
                <template slot="label">{{$t('companies.send_alerts')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.estado.value"
                prop="estado"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usercompaniesfilter"
              >
                <template slot="label">{{$t('companies.active')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.codPGN.value"
                prop="codPGN"
                :options="sedesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usercompaniesfilter"
              >
                <template slot="label">{{$t('app.location_link')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.nombreAgrupacion.value"
                prop="nombreAgrupacion"
                :options="listGroupingForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usercompaniesfilter"
              >
                <template slot="label">{{$t('app.single_grouping')}}</template>
              </AccessibleElSelect>
            </div>
            
            <div>
              <AccessibleElSelect
                v-model="form.temporal.value"
                prop="temporal"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usercompaniesfilter"
              >
                <template slot="label">{{$t('app.vinculo_temporal')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email')}}
                <el-form-item prop="email">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.email.value"
                    maxlength="500"
                  />
                </el-form-item>
              </label>
            </div>
            
            <div v-if="hasModuleNotificacionesTerceros">
              <AccessibleElSelect
                v-model="form.conPoderesDelegados.value"
                prop="conPoderesDelegados"
                :options="valuesForAccessibleSelect"
                id-prefix="usercompaniesfilter"
              >
                <template slot="label">{{$t('companies.dont_alert_delegated')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import moment from 'moment'
import { i18n } from '@/i18n'
import { getSedesByEmpresa } from '@/services/app/getSedesByEmpresa'
import { getLocations } from '@/services/app/getLocations'
// import { mapGetters } from 'vuex'
import { getAgrupacionesNombreCompanies } from '@/services/configurations/grouping/getAgrupacionesNombreCompanies'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'userscompanies',
      isOpen: this.panelOpen,
      form: {
        cif: { label: i18n.t('companies.cif'), value: '' },
        name: { label: i18n.t('app.nombre_cif'), value: '' },
        automatic_download: { label: i18n.t('companies.automatic_download'), value: '' },
        send_alerts: { label: i18n.t('companies.send_alerts'), value: '' },
        fechaAltaDesde: { label: i18n.t('companies.f_alta_desde'), value: '' },
        fechaAltaHasta: { label: i18n.t('companies.f_alta_hasta'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        temporal: { label: i18n.t('app.temporal'), value: '' },
        estado: { label: i18n.t('companies.active'), value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
        codPGN: { label: i18n.t('app.location_link'), value: '' },
        conPoderesDelegados: { label: i18n.t('companies.dont_alert_delegated'), value: '' }
      },
      listGrouping: [],
      sedes: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    hasModuleNotificacionesTerceros () {
      return this.$store.getters['auth/hasModuleNotificacionesTerceros'] 
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    sedesForAccessibleSelect: function () {
      return this.sedes.map(item => ({
        id: item.id,
        name: item.label,
        value: item.value
      }))
    },
    listGroupingForAccessibleSelect: function () {
      return this.listGrouping.map(item => ({
        id: item,
        name: item,
        value: item
      }))
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  mounted: async function () {
    this.sedes = []
    let locs
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      locs = await getLocations()
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
    } else {
      locs = await getSedesByEmpresa()
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
    }
    if (!locs.blnError) {
      locs.PGNS.forEach(row => {
        this.sedes.push({ id: row.IdPGN, label: row.Nombre, value: row.Codigo })
      })
    }
    
    const dataAgrupaciones = await getAgrupacionesNombreCompanies()
    if (dataAgrupaciones.blnError === true) {
      this.doFeedback(dataAgrupaciones.msgError + ' [Código de error: ' + dataAgrupaciones.codError + ']')
    }
    this.listGrouping = dataAgrupaciones.Respuesta
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.cif.value = _temp.cif !== undefined && _temp.cif.value !== '' ? _temp.cif.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.automatic_download.value = _temp.automatic_download !== undefined && _temp.automatic_download.value !== '' ? _temp.automatic_download.value : ''
        this.form.send_alerts.value = _temp.send_alerts !== undefined && _temp.send_alerts.value !== '' ? _temp.send_alerts.value : ''
        this.form.fechaAltaDesde.value = _temp.fechaAltaDesde !== undefined && _temp.fechaAltaDesde.value !== '' ? _temp.fechaAltaDesde.value : ''
        this.form.fechaAltaHasta.value = _temp.fechaAltaHasta !== undefined && _temp.fechaAltaHasta.value !== '' ? _temp.fechaAltaHasta.value : ''
        this.form.estado.value = _temp.estado !== undefined && _temp.estado.value !== '' ? _temp.estado.value : ''
        this.form.temporal.value = _temp.temporal !== undefined && _temp.temporal.value !== '' ? _temp.temporal.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.nombreAgrupacion.value = _temp.nombreAgrupacion !== undefined && _temp.nombreAgrupacion.value !== '' ? _temp.nombreAgrupacion.value : ''
        this.form.codPGN.value = _temp.codPGN !== undefined && _temp.codPGN.value !== '' ? _temp.codPGN.value : ''
        this.form.conPoderesDelegados.value = _temp.conPoderesDelegados !== undefined && _temp.conPoderesDelegados.value !== '' ? _temp.conPoderesDelegados.value : ''
      }
    },
    watchFormHandler: function ({ fechaAltaDesde, fechaAltaHasta, send_alerts, automatic_download, estado }) {
      if (fechaAltaDesde.value !== undefined && moment(fechaAltaDesde.value).isValid()) {
        this.form.fechaAltaDesde.value = moment(fechaAltaDesde.value).format('YYYY-MM-DD[T00:00:00]')
      } else {
        this.form.fechaAltaDesde.value = ''
      }
      if (fechaAltaHasta.value !== undefined && moment(fechaAltaHasta.value).isValid()) {
        this.form.fechaAltaHasta.value = moment(fechaAltaHasta.value).format('YYYY-MM-DD[T23:59:59]')
      } else {
        this.form.fechaAltaHasta.value = ''
      }
      if (automatic_download !== undefined && automatic_download.value) {
        this.form.automatic_download.value = !!automatic_download.value
      }
      if (send_alerts !== undefined && send_alerts.value) {
        this.form.send_alerts.value = !!send_alerts.value
      }
      if (estado !== undefined && estado.value) {
        this.form.estado.value = !!estado.value
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        cif: { label: 'CIF', value: '' },
        name: { label: 'Razón social', value: '' },
        automatic_download: { label: 'Descarga automática', value: '' },
        send_alerts: { label: 'Enviar avisos', value: '' },
        fechaAltaDesde: { label: 'F. alta desde', value: '' },
        estado: { label: i18n.t('companies.active'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        temporal: { label: i18n.t('app.temporal'), value: '' },
        fechaAltaHasta: { label: 'F. alta hasta', value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
        codPGN: { label: i18n.t('app.location_link'), value: '' },
        conPoderesDelegados: { label: i18n.t('companies.dont_alert_delegated'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
